import { selectFromRouteCalendarSummaryDto } from '../../models';

export default selectFromRouteCalendarSummaryDto()
  .uuid.name.startDate.hexColor
  .isDispatched
  .isStarted
  .driverName
  .shiftStartTime.shiftEndTime
  .toString();
